const images = [
  {
    imgURL:
      "/NHS.png",
    imgAlt: "img-1",
    heading: "NHS(UK)",
    desc: "#Healthcare",
  },
  {
    imgURL:
      "/fin1_pravisht.png",
    imgAlt: "img-2",
    heading: "TradeAi1",
    desc: "#Fintech"
  },
  {
    imgURL:
      "/My Health Buddy.png",
    imgAlt: "img-3",
    heading: "MyHealthBuddy",
    desc: "#WellnessManagement"
  },
  {
    imgURL:
      "/ploto2plot.png",
    imgAlt: "img-4",
    heading: "Agritech",
    desc: "#Agriculture"
  },
  {
    imgURL:
      "/WeMa.png",
    imgAlt: "img-5",
    heading: "SYML",
    desc: "#Healthcare"
  },
  // {
  //   imgURL:
  //     "/image2.svg",
  //   imgAlt: "img-6",
  //   heading: "Toller Nuts",
  //   desc: "DRY FRUITS"
  // },
  // {
  //   imgURL:
  //     "/image1.svg",
  //   imgAlt: "img-7",
  //   heading: "One True Pairing",
  //   desc: "CLOTHES"
  // },
  // {
  //   imgURL:
  //     "/image3.svg",
  //   imgAlt: "img-8",
  //   heading: "Welcome Shoes",
  //   desc: "SHOES"
  // },
  // {
  //   imgURL:
  //     "/image2.svg",
  //   imgAlt: "img-9",
  //   heading: "Toller Nuts",
  //   desc: "DRY FRUITS"
  // },
  // {
  //   imgURL:
  //     "/image1.svg",
  //   imgAlt: "img-10",
  //   heading: "One True Pairing",
  //   desc: "CLOTHES"
  // },
  // {
  //   imgURL:
  //     "/image3.svg",
  //   imgAlt: "img-11",
  //   heading: "Welcome Shoes",
  //   desc: "SHOES"
  // }
];

export default images;
